export const DataStatePage =
{
    dsDesconocido: 'desconocido',
    dsInsert: 'insert',
    dsEdit: 'edit',
    dsSearch: 'search',    
};

export const DataStateModal =
{
    dsClosed: false,
    dsOpen: true
}

export const ModoModal =
{
    SinDefinir : '',
    Back: 'back',
    Undo: 'undo',
    Delete: 'delete',    
};

export const ModoModalIdioma =
{
    Closed: 'close',
    Edit: 'edit',
    New: 'new'
};

export const TipoOthelloFieldGrid =
{
    OthelloComboBox: 'OthelloComboBox',
    OthelloEdit: 'OthelloEdit',
    OthelloImagen: 'OthelloImagen',
    OthelloButton: 'OthelloButton',
    OthelloCurrency: 'OthelloCurrency',
    OthelloCurrency4Dec: 'OthelloCurrency4Dec',
    OthelloCheckBox: 'OthelloCheckBox',
    OthelloDateTime: 'OthelloDateTime',
    OthelloDate: 'OthelloDate',
    OthelloCurrencyNullable: 'OthelloCurrencyNullable',
    OthelloEditLargo: 'OthelloEditLargo'
};

export const ModelosOficina = [
    { valor: "0", name: "Clasico" },
    { valor: "1", name: "Lista" },
    { valor: "2", name: "Imagen con Lista" }];

export const TiposOficina = [
    { valor: "0", name: "Estandar" },
    { valor: "1", name: "CaminoSantiago" },
    { valor: "2", name: "Ruta" },
    { valor: "3", name: "Venta" },
    { valor: "4", name: "Corporativa" },
];

export const TipoOficina =
{
    Estandar: 0,
    CaminoSantiago: 1,
    Ruta: 2,
    Venta: 3,
    Corporativa: 4
};

export const OpcionSiNo = [
{ valor: "0", name: "No" },
{ valor: "1", name: "Si" }];


export const OpcionSiNoChar = [
    { valor: "N", name: "No" },
    { valor: "S", name: "Si" }];

export const LimiteProximidad = [
    { valor: "0", name: "Ninguna" },
    { valor: "1", name: "25" },
    { valor: "2", name: "50" },
    { valor: "3", name: "75" },
    { valor: "4", name: "100" },
    { valor: "5", name: "200" }];

export const Roles = {
    SuperUsuario : -1,
    Administrador : 0,
    Usuario : 1,
    UsuarioApp : 2
}

export const RolesUsuarios = [
    { valor: Roles.SuperUsuario, name: "SuperUsuario" },
    { valor: Roles.Administrador, name: "Administrador" },
    { valor: Roles.Usuario, name: "Usuario" },
    { valor: Roles.UsuarioApp, name: "UsuarioApp" }];

export const TipoArea =
{
    /// Area normal implica que tiene un funcionamiento normal, basado en si es afiliado 
    Normal: 0,
    /// Implica que los pois se gestiona de una manera distinta, es decir, como notificacion, noticia, agenda, por tanto no aperecera en los mapas
    Agenda: 1,
    /// Implica que en el mapa principal de menu, se va a mostrar siempre
    Principal: 2,
    /// Implica que el area direcciona a una web
    Web: 3,
    /// acceso a opciones externas que no funcionan dentro de la opcion web de las apps
    Externo: 4,
    /// Acceso al tiempo en una localidad
    Tiempo: 5,
    /// Gestiona la opcion de estar en un mes concreto y nos lleva al mes actual
    Calendario: 6,
    Telefono: 7,
    Whastapp: 8,
    /// Realidad Aumentada    
    RealidadAumentada : 9
};


export const TiposArea = [
    { valor: TipoArea.Normal, name: "Estandar" },
    { valor: TipoArea.Agenda, name: "Agenda" },
    { valor: TipoArea.Principal, name: "Principal" },
    { valor: TipoArea.Web, name: "Web" },
    { valor: TipoArea.Externo, name: "Externo" },
    { valor: TipoArea.Tiempo, name: "Tiempo" },
    { valor: TipoArea.Calendario, name: "Calendario" },
    { valor: TipoArea.Telefono, name: "Telefono" },
    { valor: TipoArea.Whastapp, name: "WhastApp" },
    { valor: TipoArea.RealidadAumentada, name: "Realidad Aumentada" }
];

export const OrdenacionPoi = {
    Titulo: 0,
    OrdenVisual: 1,
    Proximidad: 2
};

export const OrdenacionPois = [
    { valor: OrdenacionPoi.Titulo, name: "Por Nombre POI" },
    { valor: OrdenacionPoi.OrdenVisual, name: "Por Orden Visual" },   
    { valor: OrdenacionPoi.Proximidad, name: "Por Proximidad" }];


export const  Visibilidad = {
    No : -1,
    Si : 0,
}

export const OpcionVisibilidad = [
    { valor: Visibilidad.No, name: "No" },
    { valor: Visibilidad.Si, name: "Si" }];


export const VisibilidadPoi = {
    Todos : -1,
    No: 1,
    Si: 0,
}

export const OpcionVisibilidadPoi = [
    { valor: VisibilidadPoi.No, name: "No" },
    { valor: VisibilidadPoi.Si, name: "Si" }];


export const TiposCategorias = {
    SinCategoria: '0',
    UnaEstrella: '1',
    DosEstrellas: '2',
    TresEstrellas: '3',
    CuatroEstrellas: '4',
    CincoEstrellas : '5',
    HostalUnaEstrella : '6',
    HostalDosEstrella : '7',
    PuntoMotero : '8',
    Escorial : '9',
    UnaLlave : 'a',
    DosLlaves : 'b',
    TresLlaves: 'c',
    InteresPeregrinos: 'd',
    UnaEspiga : 'e',
    DosEspigas : 'f',
    TresEspigas : 'g',
    CuatroEspigas : 'h',
    CincoEspigas: 'i',
    Accesible : 'j',    
}

 export const Categorias =[
     { valor: TiposCategorias.SinCategoria, name: "Sin Categoria" },
     { valor: TiposCategorias.UnaEstrella, name: "Una Estrella" },
     { valor: TiposCategorias.DosEstrellas, name: "Dos Estrellas" },
     { valor: TiposCategorias.TresEstrellas, name: "Tres Estrellas" },
     { valor: TiposCategorias.CuatroEstrellas, name: "Cuatro Estrellas" },
     { valor: TiposCategorias.CincoEstrellas, name: "Cinco Estrellas" },
     { valor: TiposCategorias.HostalUnaEstrella, name: "Hostal Una Estrella" },
     { valor: TiposCategorias.HostalDosEstrella, name: "Hostal Dos Estrellas" },
     { valor: TiposCategorias.PuntoMotero, name: "Punto Motero" },
     { valor: TiposCategorias.Escorial, name: "Escorial" },
     { valor: TiposCategorias.UnaLlave, name: "Una Llave" },
     { valor: TiposCategorias.DosLlaves, name: "Dos Llaves" },
     { valor: TiposCategorias.TresLlaves, name: "Tres Llaves" },
     { valor: TiposCategorias.InteresPeregrinos, name: "Interes Peregrinos" },
     { valor: TiposCategorias.UnaEspiga, name: "Una Espiga" },
     { valor: TiposCategorias.DosEspigas, name: "Dos Espigas" },
     { valor: TiposCategorias.TresEspigas, name: "Tres Espigas" },
     { valor: TiposCategorias.CuatroEspigas, name: "Cuatro Espigas" },
     { valor: TiposCategorias.CincoEspigas, name: "Cinco Espigas" },
     { valor: TiposCategorias.Accesible, name: "Accesible" },          
];

export const ModoAreaPoi = {
    Total : 0,
    ModoArea : 1,
    ModoPoi : 2,
}

export const ModoAreasPoi = [
    { valor: ModoAreaPoi.Total, name: "Total" },
    { valor: ModoAreaPoi.ModoArea, name: "Modo Areas" },
    { valor: ModoAreaPoi.ModoPoi, name: "Modo Pois" }]; 

export const ModoVisualizaNotificar = {
    NotificarYVisualizar : 0,
    Notificar : 1,
    Visualizar : 2,
}

export const ModosVisualizaNotifica = [
    { valor: ModoVisualizaNotificar.NotificarYVisualizar, name: "Notificar Y Visualizar" },
    { valor: ModoVisualizaNotificar.Notificar, name: "Notificar" },
    { valor: ModoVisualizaNotificar.Visualizar, name: "Visualizar" }];


export const PopUpResult =
{
    Closed: '',
    OK: 'ok',
    KO: 'ko',
    Info: 'info'
};

export const ModoRuta = {
    Automatica: 0,
    Manual: 1   
}

export const ModosRuta = [
    { valor: ModoRuta.Automatica, name: "Automatica" },
    { valor: ModoRuta.Manual, name: "Manual"  }]; 


export const MetodoRuta = {
    Coche: 0,
    Bicicleta: 1,
    APie: 2
    //Transit, aqui se puede poner hora de salida, llegada https://developers.google.com/maps/documentation/directions/intro#TravelModes
}

export const MetodosRuta = [
    { valor: MetodoRuta.Coche, name: "Coche" },
    { valor: MetodoRuta.Bicicleta, name: "Bicicleta" },
    { valor: MetodoRuta.APie, name: "A Pie" }]; 

export const ModelosArea = [
    { valor: "0", name: "Clasico" },
    { valor: "1", name: "Lista Imagen" },
   ];

export const TiposInstalacionReserva = {
    Piscina: 0,
    Padel: 1,
    Tenis: 2,
    Evento: 3,
    Excursiones : 4,
    Museo: 5,
    Futbol: 6,
    Polideportivo: 7,
    Fronton: 8,
    Gimnasio: 9,
    Inscripcion: 10,
    Parque : 11
}

export const OpcionTiposInstalacionReserva = [
    { valor: TiposInstalacionReserva.Piscina, name: "Piscina" },
    { valor: TiposInstalacionReserva.Padel, name: "Padel" },
    { valor: TiposInstalacionReserva.Tenis, name: "Tenis" },
    { valor: TiposInstalacionReserva.Evento, name: "Evento" },
    { valor: TiposInstalacionReserva.Excursiones, name: "Excursiones" },
    { valor: TiposInstalacionReserva.Museo, name: "Museo" },
    { valor: TiposInstalacionReserva.Futbol, name: "Futbol" },
    { valor: TiposInstalacionReserva.Polideportivo, name: "Polideportivo" },
    { valor: TiposInstalacionReserva.Fronton, name: "Fronton" },
    { valor: TiposInstalacionReserva.Gimnasio, name: "Gimnasio" },
    { valor: TiposInstalacionReserva.Inscripcion, name: "Inscripcion" },
    { valor: TiposInstalacionReserva.Parque, name: "Parque" }];

export const MessageOthelloBoxButtons = {
    //
    // Resumen:
    //     The message box contains an OK button.
    OK: 0,
    //
    // Resumen:
    //     The message box contains OK and Cancel buttons.
    OKCancel: 1,
    //
    // Resumen:
    //     The message box contains Abort, Retry, and Ignore buttons.
    AbortRetryIgnore: 2,
    //
    // Resumen:
    //     The message box contains Yes, No, and Cancel buttons.
    YesNoCancel: 3,
    //
    // Resumen:
    //     The message box contains Yes and No buttons.
    YesNo: 4,
    //
    // Resumen:
    //     The message box contains Retry and Cancel buttons.
    RetryCancel: 5
}

export const DialogOthelloResult = {

    None: 0,
    OK: 1,
    Cancel: 2,
    Abort: 3,
    Retry: 4,
    Ignore: 5,
    Yes: 6,
    No: 7
}

export const EstadoReserva = {
    Confirmada : 0,
    Cancelada : 1
}

export const EstadosReserva = [
    { valor: EstadoReserva.Confirmada, name: "Confirmada" },
    { valor: EstadoReserva.Cancelada, name: "Cancelada" },
];

export const ResultadoReserva = {
    OK : 0,
    SinDisponibilidad : 1,
    ErrorExcepcion : 2,
    UsuarioMaxTramosDia: 3,
    OkAFaltaDePago: 4,
}

export const  ResultadoPagoReserva = {
    OK : 0,
    KO: 1,
    OperacionNoValida : 2,
    ErrorExcepcion : 3,
    ReservaNoEncontrada : 4,
    PasarelaNoExiste: 5    
}


export const  TiposEntrega = {
    SinDefinir : 0,
    EnLocal : 1,
    EnCasa : 2,
    EnLocalYCasa : 3,
    Comer : 4,
    EnLocalYComer : 5,
    EnCasaYComer : 6,
    EnLocalYCasaYComer : 7
}

export const TipoEntrega = [
    { valor: TiposEntrega.SinDefinir, name : "Sin Definir" },
    { valor: TiposEntrega.EnLocal, name : "En el Local" },
    { valor: TiposEntrega.EnCasa, name : "En Casa" },
    { valor: TiposEntrega.Comer, name : "Comer" },
    { valor: TiposEntrega.EnLocalYCasa, name : "En el Local y en Casa" },
    { valor: TiposEntrega.EnLocalYComer, name : "En el Local y Comer" },
    { valor: TiposEntrega.EnCasaYComer, name : "En Casa y Comer" },
    { valor: TiposEntrega.EnLocalYCasaYComer, name : "En el Local y en Casa y Comer" }

];


export const TipoEntregaCombo = [
    { valor: TiposEntrega.EnLocal, name: "En el Local" },
    { valor: TiposEntrega.EnCasa, name: "En Casa" },
    { valor: TiposEntrega.Comer, name: "Comer" },  
];

export const EstadoPedido = {
    Procesando: 0,
    Tramitado: 1,
    PendientePago: 2,
    EnEspera: 3,
    Enviado: 4,
    Completado: 5,
    Cancelado: 6,
    Reembolsado: 7,
    Fallido: 8
}


export const EstadosPedido = [
    { valor: EstadoPedido.Procesando, name: "Procesando" },
    { valor: EstadoPedido.Tramitado, name: "Tramitado" },
    { valor: EstadoPedido.PendientePago, name: "Pendiente de Pago" },
    { valor: EstadoPedido.EnEspera, name: "En Espera" },
    { valor: EstadoPedido.Enviado, name: "Enviado" },
    { valor: EstadoPedido.Completado, name: "Completado" },
    { valor: EstadoPedido.Cancelado, name: "Cancelado" },
    { valor: EstadoPedido.Reembolsado, name: "Reembolsado" },
    { valor: EstadoPedido.Fallido, name: "Fallido" }

];


export const OrdenaCategoria = {
    Titulo: 0,
    OrdenVisual: 1,
};

export const OrdenacionCategoria = [
    { valor: OrdenaCategoria.Titulo, name: "Por Nombre" },
    { valor: OrdenaCategoria.OrdenVisual, name: "Por Orden Visual" }];    

export const EstadoArticulo = {
    EnStock : 0,
    Agotado : 1
}


export const EstadosArticulo = [
    { valor: EstadoArticulo.EnStock, name: "En Stock" },
    { valor: EstadoArticulo.Agotado, name: "Agotado" }];  


export const TipoPeticion = {
    Establecimiento: 1,
    Contacto: 2
}

export const TiposPeticion = [
    { valor: TipoPeticion.Establecimiento, name: "Establecimiento" },
    { valor: TipoPeticion.Contacto, name: "Contacto" }];  

export const TipoEncuenta = {
    Normal: 0,
    Juego: 1    
}

export const TiposEncuenta = [
    { valor: TipoEncuenta.ComboUnoDiez, name: "Normal" },
    { valor: TipoEncuenta.Juego, name: "Juego" },
];

export const TipoPreguntaEncuenta = {
    ComboUnoDiez : 0,
    SiNo : 1,
    Estrellas : 2,
    ComboBienMalRegular: 3,
    Combo: 4,
    TextoLibre: 5,
    Provincias: 6,
    Paises: 7,
    PreSelecOpcion: 8,
    Pista: 9
}

export const TiposPreguntaEncuenta = [
    { valor: TipoPreguntaEncuenta.ComboUnoDiez, name: "Valoracion Numerica" },
    { valor: TipoPreguntaEncuenta.SiNo, name: "Si-No" },
    { valor: TipoPreguntaEncuenta.Estrellas, name: "Estrellas" },
    { valor: TipoPreguntaEncuenta.ComboBienMalRegular, name: "Escala" },
    { valor: TipoPreguntaEncuenta.Combo, name: "Combo Opciones" },
    { valor: TipoPreguntaEncuenta.TextoLibre, name: "TextoLibre" },
    { valor: TipoPreguntaEncuenta.Provincias, name: "Provincias" },
    { valor: TipoPreguntaEncuenta.Paises, name: "Paises" },
    { valor: TipoPreguntaEncuenta.PreSelecOpcion, name: "Preseleccion Opcion" },
    { valor: TipoPreguntaEncuenta.Pista, name: "Pista" },    
];  

export const OpcionSiNoEncuesta = [
    { valor: "0", name: "No" },
    { valor: "10", name: "Si" }];

export const OpcionComboBienMalRegularEncuesta = [
    { valor: "10", name: "Excelente" },
    { valor: "7.5", name: "Buena" },
    { valor: "5", name: "Regular" },
    { valor: "2.5", name: "Mala" },
    { valor: "0", name: "Muy Mala" }];

export const OpcionComboUnoDiezEncuesta = [
    { valor: "0", name: "Cero" },
    { valor: "1", name: "Uno" },
    { valor: "2", name: "Dos" },
    { valor: "3", name: "Tres" },
    { valor: "4", name: "Cuatro" },
    { valor: "5", name: "Cinco" },
    { valor: "6", name: "Seis" },
    { valor: "7", name: "Siete" },
    { valor: "8", name: "Ocho" },
    { valor: "9", name: "Nueve" },
    { valor: "10", name: "Diez" }];

export const OpcionEstrellasEncuesta = [
    { valor: "10", name: "Cinco Estrellas" },
    { valor: "8", name: "Cuatro Estrellas" },
    { valor: "6", name: "Tres Estrellas" },
    { valor: "4", name: "Dos Estrellas" },
    { valor: "2", name: "Una Estrella" },
    { valor: "0", name: "Ninguna" }];


export const TipoBusquedaEstadisticas = {
    Ultimos30: 0,
    Ultimo180: 1,
    Ultimo365: 2,
    EsteMes: 3,
    ElMesPasado: 4,
    DesdeSiempre: 5,
    Personalizado: 6
}

export const TiposBusquedaEstadisticas = [

    { valor: TipoBusquedaEstadisticas.Ultimos30, name: "Ultimos 30 dias" },
    { valor: TipoBusquedaEstadisticas.Ultimo180, name: "Ultimos 180 dias" },
    { valor: TipoBusquedaEstadisticas.Ultimo365, name: "Ultimos 365 dias" },
    { valor: TipoBusquedaEstadisticas.EsteMes, name: "Este mes" },
    { valor: TipoBusquedaEstadisticas.ElMesPasado, name: "El mes pasado" },
    { valor: TipoBusquedaEstadisticas.DesdeSiempre, name: "Desde siempre" },
    { valor: TipoBusquedaEstadisticas.Personalizado, name: "Definir fechas" }
]

export const TipoValidacionEncuenta = {
    SinValidacion: 0,
    MedianteLogin: 1
}


export const TiposValidacionEncuenta = [
    { valor: TipoValidacionEncuenta.SinValidacion, name: "Sin Validacion" },
    { valor: TipoValidacionEncuenta.MedianteLogin, name: "Mediante Login" }];  


export const FiltroVerReservas = [
    { valor: "0", name: "Todas" },
    { valor: "1", name: "Mis Reservas" }];  


export const OpcionesNominaciones = {
    Nombre: "N",
    Apellidos: "A",
    DNI: "D",
    Sexo: "G",
    Edad: "O",
    Telefono: "T",
    Email: "E",
    Club: "B",
    Direccion: "C",
    Procedencia: "P",
    Talla: "S",
    NumRegistroSanitario: "M",
    CodigoPostal: "L",
    FechaNacimiento: "F",
    SabeNadar: "H",
    Madrugadores: "I",
    Curso :"Y"
}

export const OpcionesAutorizaciones = {
    NombreApellidosAutoriza : 'N',
    DNIAutoriza : 'D',
    TelefonoAutoriza : 'T',
    AutorizoComo : 'R',
    NombreApellidos : 'A',
    DNI : 'B',
}

export const OpcionTipoMapa = [
    { valor: 0, name: "Ninguno" },
    { valor: 1, name: "Normal" },
    { valor: 2, name: "Satelite" },
    { valor: 3, name: "Terreno" },
    { valor: 4, name: "Hibrida" }];

export const DriversPasarela = [
    { valor: "1", name: "RedSys" },
    { valor: "2", name: "PayComet" },
    { valor: "3", name: "AddOnPayments" },
    { valor: "4", name: "CecaBank" }]

export const OpcionSiNoEntero = [
    { valor: 0, name: "No" },
    { valor: 1, name: "Si" }];

export const VisibilidadWeb = {
    No: -1,
    Si: 0,
    Oculta: 1,
    SiModoIframe : 2
}

export const OpcionVisibilidadWeb = [
    { valor: VisibilidadWeb.No, name: "No" },
    { valor: VisibilidadWeb.Si, name: "Si" },
    { valor: VisibilidadWeb.Oculta, name: "Oculta" },
    { valor: VisibilidadWeb.SiModoIframe, name: "Si Modo Iframe" }];

export const TipoVisualizacionInstalaciones = {
    Estandar: 0,
    Grafica: 1,
    GraficaPosiciones : 2
}


export const TiposVisualizacionInstalaciones = [
    { valor: TipoVisualizacionInstalaciones.Estandar, name: "Estandar" },
    { valor: TipoVisualizacionInstalaciones.Grafica, name: "Grafica" },
    { valor: TipoVisualizacionInstalaciones.GraficaPosiciones, name: "Grafica Posiciones" }];

export const TipoGraficoInstalaciones = {
    Cuadrado: 0,
    Circulo: 1    
}

export const TiposGraficoInstalaciones = [
    { valor: TipoGraficoInstalaciones.Cuadrado, name: "Cuadrado" },
    { valor: TipoGraficoInstalaciones.Circulo, name: "Circulo" }];

export const TipoExtraInstalaciones = {
    PorReserva: 0,
    PorPax: 1
}

export const TiposExtraInstalaciones = [
    { valor: TipoExtraInstalaciones.PorReserva, name: "Por Reserva" },
    { valor: TipoExtraInstalaciones.PorPax, name: "Por Pax" }];

export const OpcionVisibilidadDashboard = [
    { valor: 7, name: "Ultimos 7 dias" },
    { valor: 14, name: "Ultimas 14 dias" },
    { valor: 30, name: "Ultimos 30 dias" },
    { valor: 60, name: "Ultimos 60 dias" },
    { valor: 90, name: "Ultimos 90 dias" },
    { valor: 180, name: "Ultimos 6 meses" },
    { valor: 365, name: "Ultimo año" },
    { valor: -1, name: "Indicar Fechas" },
];


export const OpcionVisibilidadReservas= [
    { valor: 0, name: "Actuales" },
    { valor: 7, name: "Ultimos 7 dias" },
    { valor: 14, name: "Ultimas 14 dias" },
    { valor: 30, name: "Ultimos 30 dias" },
    { valor: 60, name: "Ultimos 60 dias" },
    { valor: 90, name: "Ultimos 90 dias" },
    { valor: 180, name: "Ultimos 6 meses" },
    { valor: 365, name: "Ultimo año" },
];

export const ModoReport =
{
    Preview: 'Preview',
    Imprimir: 'print',
    Archivo: 'file',
    EMail: 'email'
}

export const EstadoNotificacionWeb = {
    SinIndicar: -1,
    Enviado: 0,
    Leido: 1,
    DescartadoBorrado: 2
}

export const TipoMensajeWeb = {
    Sistema: 0,
    Aviso: 1,
    Excepcion: 2
}


export const TiposResultadoOthello = {
    Desconocido: 0,
    Ok: 1,
    Warning: 2,
    Error: 4
}


export const OpcionSiNoStringLargo = [
    { valor: "No", name: "No" },
    { valor: "Si", name: "Si" }];


export const ModeloCerradura = {
    Desconocido: 0,
    Paddword: 1
}

export const TiposModeloCerradura = [
    { valor: ModeloCerradura.Desconocido, name: "Desconocido" },
    { valor: ModeloCerradura.Paddword, name: "Paddword" }];
